import "../chunk-BUSYA2B4.js";
const onlyTry = (cb) => {
  try {
    cb();
  } catch {
  }
};
export {
  onlyTry
};
//# sourceMappingURL=only-try.js.map